export default __webpack_public_path__ + "static/media/email.64d1b5e2.svg";